import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class RegisterRoute extends Route {
  @service declare router: RouterService;
  beforeModel() {
    const session = localStorage.getItem('session');
    if (session) {
      this.router.transitionTo('auth.smartphone');
    }
  }
}
